/**
 * Whether the screen is phone-sized — the one breakpoint the app changes *structure* at.
 *
 * Most of the phone layout is CSS (`@media (max-width: 760px)` in styles.css). This hook is for
 * the few places where a phone needs different markup rather than different styling: the Log,
 * which is a seventeen-column spreadsheet on a desk and a list of cards in a hand. The number
 * is written in both places; change them together.
 */

import { useEffect, useState } from "react";

export const PHONE_QUERY = "(max-width: 760px)";

export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(() => window.matchMedia(PHONE_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(query.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);
  return phone;
}
